import { render, staticRenderFns } from "./RelatorioCanceladosListFiltro.vue?vue&type=template&id=13cbdfe4"
import script from "./RelatorioCanceladosListFiltro.vue?vue&type=script&lang=js"
export * from "./RelatorioCanceladosListFiltro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports